import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-3" }
const _hoisted_2 = { class: "px-6 py-3" }
const _hoisted_3 = { class: "space-y-6" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "w-8/12 px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_7 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_8 = { class: "px-6 py-5 text-sm text-gray-900 break-all whitespace-nowrap" }
const _hoisted_9 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_10 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_11 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_12 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_13 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import TabComponent from '@/components/TabComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import StatusPill from '@/components/StatusPill.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import PagePagination from '@/components/PagePagination.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import { ref, onMounted, watch } from 'vue';
import { paginatePage } from '@/helpers/PageHelper';
import ReportService from '@/classes/ReportService';
import { startOfYear, endOfYear } from 'date-fns';
import DropdownData from '@/classes/DropdownData';
import { formatDate, formatTime } from '@/helpers/TimeFormatter'
import { formatter } from '@/helpers/NumberHelper'
import throttle from "lodash/throttle";


interface Patient {
    first_name: string,
    last_name: string
}

interface individualBooking {
    patient: Patient
    booking_type: string,
    status: string,
    booking_date: Date,
    booking_start_time: Date,
    booking_end_time: Date,
    booking_created_date: Date
}

interface Item {
    data: individualBooking[]
    total: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IndividualBooking',
  setup(__props) {

const loader      = ref(false);
const showSuccess = ref(false);
const showError   = ref(false);
const errorMsg    = ref();
const goToPage    = ref();
const packageIDs    = ref();
const riderIDs    = ref();
const patientIDs    = ref();
const searchText  = ref();

const items = ref<Item>({
    data: [],
    total: 0
});

const filters = ref({
    dateRange: [
        startOfYear(new Date).toISOString(),
        endOfYear(new Date).toISOString(),
    ],
    createdRange: [
        startOfYear(new Date).toISOString(),
        endOfYear(new Date).toISOString(),
    ],
    bookingType: 'All',
    bookingStatus: 'All',
    timePeriod: 'year',
    patientID: null,
    packageID: null,
    riderID: null,
})

const bookingTypes = [
    { id: '1', label: 'All', value: 'All' },
    { id: '2', label: 'New', value: 'New' },
    { id: '3', label: 'Rescheduled', value: 'Rescheduled' },
];

const bookingStatuses = [
    { id: '1', label: 'All', value: 'All'},
    { id: '2', label: 'Booked', value: 'Booked'},
    { id: '3', label: 'Cancelled', value: 'Cancelled'},
    { id: '4', label: 'No-Show', value: 'No-Show'},
    { id: '5', label: 'Done', value: 'Done'},
];

const timePeriods = [
    { id: '1', label: '24 hours', value: 'day'},
    { id: '2', label: '1 week', value: 'week'},
    { id: '3', label: '1 month', value: 'month'},
    { id: '4', label: '1 year', value: 'year'},
];

const headers: { text: string }[] = [
    { text: 'Patient ID' }, 
    { text: 'Patient Name' },
    { text: 'Package' },
    { text: 'Rider/s' },
    { text: 'Amount' },
    { text: 'Booking Type' },
    { text: 'Status' },
    { text: 'Booking Date and Time' },
    { text: 'Date Created'}
];

const getStatusColor = (status: string) => {
    if(status) {
        let color = null;
        switch (status) {
            case 'Booked':
                color = 'blue';
                break;
        
            case 'Cancelled/No-Show':
            case 'Cancelled':
                color = 'red';
                break;
        
            case 'Done':
                color = 'green';
                break;
            
            default:
                color = 'yellow'
                break;
        }

        return color;
    }

    return 'yellow';
}

const applyFilters = () => {
    fetchIndividualBookings(goToPage.value);
}

const fetchIndividualBookings = async (data: string) => {
    try {
        loader.value = true;

        const startDate     = filters.value.dateRange ? `&startDate=${filters.value.dateRange[0]}` : '';
        const endDate       = filters.value.dateRange ? `&endDate=${filters.value.dateRange[1]}` : '';
        const createdStartDate     = filters.value.createdRange ? `&createdStartDate=${filters.value.createdRange[0]}` : '';
        const createdEndDate       = filters.value.createdRange ? `&createdEndDate=${filters.value.createdRange[1]}` : '';
        const bookingType   = filters.value.bookingType ? `&bookingType=${filters.value.bookingType}` : '';
        const bookingStatus = filters.value.bookingStatus ? `&bookingStatus=${filters.value.bookingStatus}` : '';
        const timePeriod    = filters.value.timePeriod ? `&timePeriod=${filters.value.timePeriod}` : '';
        const patientID    = filters.value.patientID ? `&patientID=${filters.value.patientID}` : '';
        const packageID    = filters.value.packageID ? `&packageID=${filters.value.packageID}` : '';
        const riderID    = filters.value.riderID ? `&riderID=${filters.value.riderID}` : '';
        const queryString = searchText.value ? `&search_key=${searchText.value}` : '';
        
        goToPage.value = paginatePage(data)

        const response   = await ReportService.fetchIndividualBookings(`${goToPage.value}${startDate}${endDate}${createdStartDate}${createdEndDate}${bookingType}${bookingStatus}${timePeriod}${patientID}${packageID}${riderID}${queryString}`);
        loader.value = false;
        
        items.value = response.data;
    } catch (error: any) {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = error;

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
    }
    finally{
        loader.value = false
    }
}

const exportIndividualBookings = async () => {
    try {
        loader.value = true;

        const startDate     = filters.value.dateRange ? `&startDate=${filters.value.dateRange[0]}` : '';
        const endDate       = filters.value.dateRange ? `&endDate=${filters.value.dateRange[1]}` : '';
        const createdStartDate     = filters.value.createdRange ? `&createdStartDate=${filters.value.createdRange[0]}` : '';
        const createdEndDate       = filters.value.createdRange ? `&createdEndDate=${filters.value.createdRange[1]}` : '';
        const bookingType   = filters.value.dateRange ? `&bookingType=${filters.value.bookingType}` : '';
        const bookingStatus = filters.value.dateRange ? `&bookingStatus=${filters.value.bookingStatus}` : '';
        const timePeriod    = filters.value.dateRange ? `&timePeriod=${filters.value.timePeriod}` : '';
        const patientID    = filters.value.patientID ? `&patientID=${filters.value.patientID}` : '';
        const packageID    = filters.value.packageID ? `&packageID=${filters.value.packageID}` : '';
        const riderID    = filters.value.riderID ? `&riderID=${filters.value.riderID}` : '';
        const queryString = searchText.value ? `&search_key=${searchText.value}` : '';

        await ReportService.exportIndividualBookings(`${startDate}${endDate}${createdStartDate}${createdEndDate}${bookingType}${bookingStatus}${timePeriod}${patientID}${packageID}${riderID}${queryString}`);

        showSuccess.value = true;
    } catch (error: any) {
        showError.value = true;
        errorMsg.value  = error.response?.data.message;
    } finally {
        loader.value = false;
    }
};

const fetchPackages = async () => {
    loader.value = true

    await DropdownData.getPackages()
        .then((result: any) => {

            packageIDs.value = result.data.response;

            loader.value = false;
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error;

            if(error.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const fetchRiders = async () => {
    loader.value = true

    await DropdownData.getRiders()
        .then((result: any) => {

            riderIDs.value = result.data.response;
            
            loader.value = false;
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error;

            if(error.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const fetchPatients = async () => {
    loader.value = true

    await DropdownData.getPatients()
        .then((result: any) => {

            patientIDs.value = result.data.response;
            
            loader.value = false;
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error;

            if(error.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const searchData = (val: string) => {
    searchText.value = val
}

/**
 * ********************************
 * Wathchers
 * ********************************
 */
watch(
    searchText,
    throttle(() => {
        fetchIndividualBookings(goToPage.value)
    }, 1000)
);

onMounted(async() => {
    await fetchIndividualBookings(goToPage.value); 
    await fetchPackages();
    await fetchRiders();
    await fetchPatients();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Individual Patient Bookings",
    "show-back": "",
    backUrl: "/reports"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { "button-items": true }, {
          buttons: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(ButtonComponent, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (exportIndividualBookings())),
                class: "text-gray-900",
                secondary: "",
                exportBtn: ""
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode(" Export ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(FilterComponent, {
          "text-filters": false,
          "onUpdate:filters": applyFilters,
          textFilters: "",
          search: searchText.value,
          onFetchData: searchData
        }, {
          fields: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(DatePicker, {
                id: "dateRange",
                name: "dateRange",
                range: "",
                is24: "",
                isPresetRanges: "",
                modelValue: filters.value.dateRange,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.dateRange) = $event)),
                placeholder: "Booking Date",
                label: "Booking Date"
              }, null, 8, ["modelValue"]),
              _createVNode(DatePicker, {
                id: "createdRange",
                name: "createdRange",
                range: "",
                is24: "",
                isPresetRanges: "",
                modelValue: filters.value.createdRange,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.createdRange) = $event)),
                placeholder: "Created Date",
                label: "Created Date"
              }, null, 8, ["modelValue"]),
              _createVNode(MultiselectInput, {
                id: "timePeriod",
                name: "timePeriod",
                label: "Time Period",
                modelValue: filters.value.timePeriod,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.timePeriod) = $event)),
                placeholder: "Time Period",
                options: timePeriods
              }, null, 8, ["modelValue"]),
              _createVNode(MultiselectInput, {
                modelValue: filters.value.patientID,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.value.patientID) = $event)),
                id: "patientID",
                name: "patientID",
                label: "Patient ID",
                placeholder: "Patient ID",
                mode: "tags",
                options: patientIDs.value
              }, null, 8, ["modelValue", "options"]),
              _createVNode(MultiselectInput, {
                modelValue: filters.value.packageID,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.value.packageID) = $event)),
                id: "packageID",
                name: "packageID",
                label: "Package ID",
                placeholder: "Package ID",
                mode: "tags",
                options: packageIDs.value
              }, null, 8, ["modelValue", "options"]),
              _createVNode(MultiselectInput, {
                modelValue: filters.value.riderID,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.value.riderID) = $event)),
                id: "riderID",
                name: "riderID",
                label: "Rider ID",
                placeholder: "Rider ID",
                mode: "tags",
                options: riderIDs.value
              }, null, 8, ["modelValue", "options"]),
              _createVNode(MultiselectInput, {
                id: "bookingStatus",
                name: "bookingStatus",
                label: "Booking Status",
                modelValue: filters.value.bookingStatus,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.value.bookingStatus) = $event)),
                placeholder: "Booking Status",
                options: bookingStatuses
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["search"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(DataTable, {
          headers: headers,
          noAction: true,
          count: items.value?.total
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (individualBooking, key) => {
              return (_openBlock(), _createElementBlock("tr", { key: key }, [
                _createElementVNode("td", _hoisted_5, _toDisplayString(individualBooking.patient?.patient_id), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(`${individualBooking.patient?.first_name} ${individualBooking.patient?.last_name}`), 1),
                _createElementVNode("td", _hoisted_7, _toDisplayString(individualBooking.package_name), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(individualBooking.riders), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(formatter).format(individualBooking.total_fee)), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(individualBooking.booking_type), 1),
                _createElementVNode("td", _hoisted_11, [
                  _createVNode(StatusPill, {
                    color: getStatusColor(individualBooking.status),
                    text: individualBooking.status
                  }, null, 8, ["color", "text"])
                ]),
                _createElementVNode("td", _hoisted_12, _toDisplayString(`${_unref(formatDate)(individualBooking.booking_date)} (${_unref(formatTime)(individualBooking.booking_start_time)} - ${_unref(formatTime)(individualBooking.booking_end_time)})`), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(`${_unref(formatDate)(individualBooking.booking_created_date)} (${_unref(formatTime)(individualBooking.booking_created_date)})`), 1)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["count"]),
        _createVNode(PagePagination, {
          class: "mb-6",
          items: items.value,
          onNextPage: fetchIndividualBookings
        }, null, 8, ["items"])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[8] || (_cache[8] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[9] || (_cache[9] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Individual Bookings Export",
        content: "Export is being processed. Please check your registered email."
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[10] || (_cache[10] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[11] || (_cache[11] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})